module.exports = __webpack_public_path__ + "img/img-success.8ad39522.png";